export default __webpack_public_path__ + "static/media/ic_timeline_step_2.2b1b8e51.svg";